module.exports = __webpack_public_path__ + "static/media/service-i.606b21cb.png";